import React from 'react';
import styles from '../css/index.module.scss';

function StatusInfoComponent() {
  return (
    <div className={styles.statusInfoComponent}>
      <p>Нажмите, чтобы увидеть историю статусов</p>
    </div>
  );
}

export default StatusInfoComponent;
